module.exports = __webpack_public_path__ + "img/measure-and-change-logo-white.027bbc66.png";